"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputProps = exports.INPUT_PROPS_KEY = void 0;
exports.INPUT_PROPS_KEY = 'remotion.inputProps';
const getInputProps = () => {
    if (process.env.NODE_ENV === 'production') {
        const param = localStorage.getItem(exports.INPUT_PROPS_KEY);
        if (!param) {
            return {};
        }
        const parsed = JSON.parse(param);
        return parsed;
    }
    return process.env.INPUT_PROPS;
};
exports.getInputProps = getInputProps;
//# sourceMappingURL=input-props.js.map